import Vue from "vue";
import VueRouter from "vue-router";

// Public
import PublicAppLayout from '@/components/layouts/PublicAppLayout.vue'
// import Home from '@/components/pages/public/Home.vue'
import About from '@/components/pages/public/About.vue'
// import PageServices from '@/components/pages/public/PageServices.vue'
import PageDemo from '@/components/pages/public/PageDemo.vue'
import PageLegalSecurity from '@/components/pages/public/PageLegalSecurity.vue'
import LandingPatrowlHears from '@/components/pages/public/landings/LandingPatrowlHears.vue'
// import LandingPatrowlDashboard from '@/components/pages/public/landings/dashboard/LandingPatrowlDashboard.vue'
// import LandingPatrowlManager from '@/components/pages/public/landings/manager/LandingPatrowlManager.vue'

// Private
import AppLogin from '@/components/pages/private/AppLogin.vue'
import AppPasswordReset from '@/components/pages/private/AppPasswordReset.vue'
import AppSignup from '@/components/pages/private/AppSignup.vue'
import AppSignupActivation from '@/components/pages/private/AppSignupActivation.vue'
import PrivateAppLayout from '@/components/layouts/PrivateAppLayout.vue'
import PrivateHome from '@/components/pages/private/PrivateHome.vue'

// Default
import SubscriptionSuccess from '@/components/pages/public/pricing/SubscriptionSuccess.vue'
import NotFound from '@/components/general/NotFound.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: PublicAppLayout,
    redirect: '/',
    children: [
      // { path: 'home', name: 'Home', component: Home },
      { path: "", name: 'LandingPatrowlHears', component: LandingPatrowlHears, alias: "/home" },
      // { path: 'services', name: 'PageServices', component: PageServices },
      { path: 'about-us', name: 'About', component: About },
      { path: 'legal', name: 'PageLegalSecurity', component: PageLegalSecurity },
      // { path: "/products/patrowl", name: 'LandingPatrowlDashboard', component: LandingPatrowlDashboard },
      // { path: "/patrowl", name: 'LandingPatrowlDashboard', component: LandingPatrowlDashboard, alias: "/products/patrowl" },
      // { path: "/products/hears", name: 'LandingPatrowlHears', component: LandingPatrowlHears, alias: "/hears" },
      // { path: "/products/manager", name: 'LandingPatrowlManager', component: LandingPatrowlManager, alias: "/manager" },
      { path: 'get-started', name: 'PageDemo', component: PageDemo,
        meta: {
          title: 'Contact us - Start your free trial',
          metaTags: [
            {
              name: 'description',
              content: 'Start your free trial - Discover our products and services.'
            },
            {
              property: 'og:description',
              content: 'Start your free trial - Discover our products and services.'
            }
          ]
        }
      },
    ]
  },
  { path: '/login', name: 'AppLogin', component: AppLogin },
  { path: '/signup', name: 'AppSignup', component: AppSignup },
  { path: '/activate', name: 'AppSignupActivation', component: AppSignupActivation },
  { path: '/reset', name: 'AppPasswordReset', component: AppPasswordReset },
  {
    path: "/portal",
    component: PrivateAppLayout,
    children: [
      { path: 'home', name: 'PrivateHome', component: PrivateHome },
      { path: 'subscription/success', name: 'SubscriptionSuccess', component: SubscriptionSuccess },
    ]
  },
  { path: '/lost', component: NotFound },
  { path: '*', component: NotFound }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  },
});

router.beforeEach((to, from, next) => {
  // console.log(to.path)
  if (!to.path.match('^/portal/.*$')){
    next();
  } else if (to.path.match('^/portal/.*$') && localStorage.getItem('authToken') !== null){
    // console.log("private ok")
    next();
  } else {
    console.log("Authorization denied.");
    next('/');
  }
});

export default router;
